import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import FluidImg from 'Components/Utility/FluidImg';
import AutoPlayVideo from 'Components/Utility/Video/AutoPlayVideo';
import ProductCover from 'Components/Utility/ProductCover';

const SliderVideo = ({
  cover,
  alt,
  src,
  ageGateRequired,
  currentSlide,
  ytCover,
  sizesOverride,
  coverType,
  displayType,
}) => {
  const [playVideo, setPlayVideo] = useState(false);

  useEffect(() => {
    setPlayVideo(false);
  }, [currentSlide]);

  const videoClick = () => {
    setPlayVideo(true);
  };

  return (
    <div className="SliderVideo">
      {(!playVideo) &&
        <div className="SliderVideo__slide">
          {!ytCover &&
            <ProductCover
              cover={cover}
              alt={alt}
              sizesOverride={sizesOverride}
              displayType={displayType}
              coverType={coverType}
            />
          }
          {ytCover &&
            <div className="responsive-image-island">
              <div className="responsive-image responsive-image--16by9">
                <FluidImg
                  ratio16by9
                  youtubeId={src}
                  className="img-force-full SliderVideo__slide__img"
                  src={cover}
                  alt={cover}
                  sizesOverride={sizesOverride}
                />
              </div>
            </div>
          }
          {!ageGateRequired &&
            <div className="slide-video-button-container SliderVideo__buttonContainer">
              <button className="SliderVideo__buttonContainer__button" onClick={() => { videoClick(); }}>
                <img src="https://cdn.fanatical.com/production/icons/youtube-icon-white.svg" alt="YouTube" loading="lazy" className="SliderVideo__buttonContainer__img" />
              </button>
            </div>
          }
        </div>
      }

      {playVideo &&
        <div className="videoWrapper">
          <AutoPlayVideo width="100%" height="auto" src={src} className="youtube-video" />
        </div>
      }
    </div>
  );
};

SliderVideo.propTypes = {
  cover: PropTypes.string,
  alt: PropTypes.string,
  src: PropTypes.string,
  ageGateRequired: PropTypes.bool,
  currentSlide: PropTypes.number,
  ytCover: PropTypes.bool,
  sizesOverride: PropTypes.string,
  coverType: PropTypes.string,
  displayType: PropTypes.string,
};

SliderVideo.defaultProps = {
  cover: '',
  alt: '',
  src: '',
  ageGateRequired: false,
  currentSlide: 1,
  ytCover: false,
  sizesOverride: '(min-width: 1520px) 1020px, (min-width: 1200px) 740px, (min-width: 992px) 620px, 100vw',
  coverType: '',
  displayType: '',
};

export default (SliderVideo);
